<div class="loader">
    <div class="dimmed" [hidden]="status == STATUS_DONE">
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
            <div class="dimmed_box"></div>
            <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
            <div class="dimmed_box"></div>
            <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
            <div class="dimmed_box"></div>
            <div class="dimmed_subtitle"></div>
        </div>
        <div class="dimmed_flex">
            <div class="dimmed_box"></div>
            <div class="dimmed_subtitle"></div>
        </div>
    </div>
    <!-- <core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading> -->
</div>

<div class="app-wrapper" *ngIf="status == STATUS_DONE && !forbidden">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
        <div class="app-main">
            <header>
                <core-title-section
                  [title]="'System Settings'"
                  [description]="'Click on any of the below settings options to access their configuration screens. Each of them will have instructions to guide you through the process.'"
                ></core-title-section>
            </header>
            <div class="box_default box_white settings-list">
                <ul class="version-status-ul">
                    <li *ngIf="allowed(SETTINGS_LIST.USERS)" (click)="open('users')" class="settings-action-users">
                        <h3>USERS</h3>
                        <span>List of system users, form to invite new ones and invitation status</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.GROUPS)" (click)="open('groups')" class="settings-action-groups">
                        <h3>USER GROUPS</h3>
                        <span>Permission groups and user assignment</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.WORKFLOWS)" (click)="open('workflows')" class="settings-action-workflows">
                        <h3>WORKFLOWS</h3>
                        <span>Design your artwork approval workflow</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.VERSIONS)" (click)="open('version-status')" class="settings-action-versions">
                        <h3>ARTWORK STATUSES</h3>
                        <span>Create artwork naming structure</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.RULES)" (click)="open('rules')" class="settings-action-rules">
                        <h3>RULES</h3>
                        <span>Define user permissions, automatic actions, and notifications</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.CATEGORIES)" (click)="open('categories')" class="settings-action-categories">
                        <h3>CATEGORIES</h3>
                        <span>Create a structure for your tags</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.FORMS)" (click)="open('forms')" class="settings-action-forms">
                        <h3>FORMS</h3>
                        <span>Manage your forms configuration</span>
                    </li>
                    <li *ngIf="allowed(SETTINGS_LIST.TOKENS)"  (click)="open('access-tokens')" class="settings-action-tokens">
                        <h3>API TOKENS</h3>
                        <span>Create an Access Token to use with the Twona API</span>
                    </li>
                    <!-- TODO set access -->
                    <li *ngIf="allowed(SETTINGS_LIST.ORGANIZATION_PROFILE )"   (click)="open('organization-profile')" class="settings-action-organization-profile">
                        <h3>ORGANIZATION</h3>
                        <span>Set your organization profile configuration</span>
                    </li>
                </ul>
            </div>

        </div>
    </section>
</div>
<core-helpers-box-http-error
    *ngIf="status == STATUS_DONE && forbidden"
    [code]="403"
    [message]="'Not allowed.'"
></core-helpers-box-http-error>
